import { getResumeBuildBaseURL } from "../Services/base-url/api-constants";
import {
  deleteCookie,
  deletedomainCookie,
  goToPdfSimpli,
  gotToDashBoardWithLocale,
  goToSignSimpli,
  goToResumeBuild,
} from "./helper";
export const ProcessLogout = (ssologout: string, domain: string, nextLogout: any, locale: string) => {
  //ssologout true/false
  //cd current domain
  //nextlg with ~ next logout
  let logoutPageUrl = "";
  let x = gotToDashBoardWithLocale(locale);

  console.log("locale", locale);

  localStorage.clear();
  sessionStorage.clear();
  deleteCookie("jwtToken");
  deleteCookie("refreshToken");
  deletedomainCookie("jwtToken");
  deleteCookie("ssoToken");
  deleteCookie("ssoauth");
  deleteCookie("legacyTicket");
  deleteCookie("ssopl");

  deleteCookie("docid");
  deleteCookie("userguid");
  deleteCookie("isPremiumUser");
  if (ssologout === "true") {
    if (!!nextLogout) {
      if (nextLogout.includes("ss")) {
        // logout from SignSimpli
        console.log("clear sign simpli");
        nextLogout = nextLogout.replace("ss", "");
        if (nextLogout.Length <= 0) {
          nextLogout = "~";
        }
        logoutPageUrl = goToSignSimpli(locale) + "/account/logout";
        logoutPageUrl = logoutPageUrl + "?ssologout=true&cd=" + domain + "&nextlg=" + nextLogout;
        console.log(logoutPageUrl);
        window.location.assign(logoutPageUrl);
      } else if (nextLogout.includes("ps")) {
        // logout from pdfSimpli
        console.log("clear pdf simpli");
        nextLogout = nextLogout.replace("ps", "");
        if (nextLogout.Length <= 0) {
          nextLogout = "~";
        }
        logoutPageUrl = goToPdfSimpli(locale) + "/account/logout";
        logoutPageUrl = logoutPageUrl + "?ssologout=true&cd=" + domain + "&nextlg=" + nextLogout;
        console.log(logoutPageUrl);
        window.location.assign(logoutPageUrl);
      } else if (nextLogout.includes("rb")) {
        // logout from resumebuild
        console.log("clear resumebuild");
        nextLogout = nextLogout.replace("rb", "");
        if (nextLogout.Length <= 0) {
          nextLogout = "~";
        }
        logoutPageUrl = goToResumeBuild(locale) + "/sign-out";
        logoutPageUrl = logoutPageUrl + "?ssologout=true&cd=" + domain + "&nextlg=" + nextLogout;
        window.location.assign(logoutPageUrl);
      } else {
        if (!!domain) {
          console.log("No nextLogout Redirect to domain :", domain);
          if (domain.includes("pdfsimpli") || domain.includes("signsimpli")) {
            window.location.assign(domain + "/account/logout");
          } else if (domain.includes("resumebuild")) {
            window.location.assign(domain + "/sign-out");
          } else {
            redirectToLegalSimpli(locale);
          }
        } else {
          console.log("No portal found !");
          redirectToLegalSimpli(locale);
        }
      }
    } else {
      if (!!domain) {
        if (domain.includes("pdfsimpli") || domain.includes("signsimpli")) {
          window.location.assign(domain + "/account/logout");
        } else if (domain.includes("resumebuild")) {
          window.location.assign(domain + "/sign-out");
        } else {
          redirectToLegalSimpli(locale);
        }
      } else {
        console.log("No nextLogout or portal found !");
        redirectToLegalSimpli(locale);
      }
    }
  } else {
    console.log("Noraml Logout ");
    redirectToLegalSimpli(locale);
  }
};

const redirectToLegalSimpli = (locale: string) => {
  let localeVal = "";
  if (!!locale) {
    localeVal = locale;
  }
  if (window.location.host.indexOf("local") > -1 || window.location.host.indexOf("test") > -1) {
    setTimeout(() => {
      window.location.href = "https://test.legalsimpli.com/" + localeVal + "app/template/sign-in";
    }, 2000);
  } else if (window.location.host.indexOf("test2") > -1) {
    setTimeout(() => {
      window.location.href = "https://test2.legalsimpli.com/" + localeVal;
    }, 2000);
  } else {
    setTimeout(() => {
      window.location.href = "https://legalsimpli.com/" + localeVal;
    }, 2000);
  }
};
